@if (isLoading) {
  <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
} @else if (pricingModelOptions?.length > 0) {
  <lh-shared-ui-select-option-button-group
    [options]="pricingModelOptions"
    [(selected)]="pricingModel"
  ></lh-shared-ui-select-option-button-group>
}
